module.exports = __webpack_public_path__ + "img/A-821-850.c7c1c763.svg";